module.exports = __webpack_public_path__ + "static/emergency-12a11e572f2979f3a1e3060bad95ef36.jpg";